"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.THIRD_PARTY_PACK = exports.THIRD_PARTY_VEHICLE = exports.COMPLETE_VEHICLE = void 0;
exports.COMPLETE_VEHICLE = 'Vehicle';
exports.THIRD_PARTY_VEHICLE = 'VehicleRC';
exports.THIRD_PARTY_PACK = 'VehicleRC_PACK';
//# sourceMappingURL=products.js.map